import { CoreExecutorResult, } from "../../core/index.js";
import { DataPsmUnwrapOrResult, } from "../operation/index.js";
import { DataPsmExecutorResultFactory, loadDataPsmSchema, } from "./data-psm-executor-utils.js";
import { replaceObjectInSchema } from "./replace-object-in-schema.js";
export async function executeDataPsmUnwrapOr(reader, createNewIdentifier, operation) {
    const schema = await loadDataPsmSchema(reader);
    if (schema === null) {
        return DataPsmExecutorResultFactory.missingSchema();
    }
    const or = await reader.readResource(operation.dataPsmOr);
    if (or.dataPsmChoices.length === 0) {
        return CoreExecutorResult.createError("Data-psm or does not have any choice.");
    }
    if (or.dataPsmChoices.length > 1) {
        return CoreExecutorResult.createError("Data-psm or has multiple choices.");
    }
    const replacementIri = or.dataPsmChoices[0];
    const changed = await replaceObjectInSchema(schema.iri, operation.dataPsmOr, replacementIri, reader);
    const changedSchema = changed.some(c => c.iri === schema.iri);
    if (changedSchema) {
        changed.map(c => c.iri === schema.iri ? { ...c, dataPsmParts: c.dataPsmParts.filter(p => p !== operation.dataPsmOr) } : c);
    }
    else {
        changed.push({ ...schema, dataPsmParts: schema.dataPsmParts.filter(p => p !== operation.dataPsmOr) });
    }
    return CoreExecutorResult.createSuccess([], changed, [operation.dataPsmOr], new DataPsmUnwrapOrResult());
}
//# sourceMappingURL=data-psm-unwrap-or-executor.js.map